import React, { useContext, useMemo } from 'react';

import TabTable from 'components/common/tabs/table';

function Vehicles({ context }) {
  const { data } = useContext(context);
  const rows = useMemo(() => {
    if (data && data.vehicles) {
      return data.vehicles.map((item, index) => {
        return {
          ...item,
          id: index,
        };
      });
    }
    return [];
  }, [data]);

  return (
    <TabTable
      schema={[
        {
          id: 'chassis_number',
          isId: true,
          label: '底盤號碼',
          editable: false,
        },
        {
          id: 'effective_date',
          label: '生效日期',
          type: 'date',
        },
        {
          id: 'end_date',
          label: '結束日期',
          type: 'date',
        },
      ]}
      setting={{
        addable: false,
        editable: false,
        deletable: false,
      }}
      collectionId={data._id}
      rows={rows}
    />
  );
}

export default Vehicles;
